import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

function PrivacyPolicy() {
  const { t } = useTranslation();
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4, backgroundColor: '#fff' }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, color: '#1976d2' }}>
          {t('privacyPolicy.pageTitle')}
        </Typography>
        <Typography variant="caption" sx={{ color: 'textSecondary', display: 'block', mb: 3 }}>
          {t('privacyPolicy.lastUpdated')}
        </Typography>
        <Divider sx={{ mb: 3 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            {t('privacyPolicy.section1Title')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'textSecondary', lineHeight: 1.8 }}>
            {t('privacyPolicy.section1Text')}
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            {t('privacyPolicy.section2Title')}
          </Typography>
          <List sx={{ pl: 2 }}>
            <ListItem>
              <ListItemText
                primary={t('privacyPolicy.personalInfoTitle')}
                secondary={t('privacyPolicy.personalInfoDesc')}
                primaryTypographyProps={{ sx: { fontWeight: 600, mb: 1 } }}
                secondaryTypographyProps={{ sx: { color: 'textSecondary' } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t('privacyPolicy.permitInfoTitle')}
                secondary={t('privacyPolicy.permitInfoDesc')}
                primaryTypographyProps={{ sx: { fontWeight: 600, mb: 1 } }}
                secondaryTypographyProps={{ sx: { color: 'textSecondary' } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t('privacyPolicy.usageDataTitle')}
                secondary={t('privacyPolicy.usageDataDesc')}
                primaryTypographyProps={{ sx: { fontWeight: 600, mb: 1 } }}
                secondaryTypographyProps={{ sx: { color: 'textSecondary' } }}
              />
            </ListItem>
          </List>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            {t('privacyPolicy.section3Title')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'textSecondary', lineHeight: 1.8 }}>
            {t('privacyPolicy.section3Intro')}
          </Typography>
          <List sx={{ pl: 2, mt: 1 }}>
            <ListItem>
              <Typography variant="body2" sx={{ color: 'textSecondary' }}>{t('privacyPolicy.usePoint1')}</Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body2" sx={{ color: 'textSecondary' }}>{t('privacyPolicy.usePoint2')}</Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body2" sx={{ color: 'textSecondary' }}>{t('privacyPolicy.usePoint3')}</Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body2" sx={{ color: 'textSecondary' }}>{t('privacyPolicy.usePoint4')}</Typography>
            </ListItem>
          </List>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            {t('privacyPolicy.section4Title')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'textSecondary', lineHeight: 1.8 }}>
            {t('privacyPolicy.section4Text')}
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            {t('privacyPolicy.section5Title')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'textSecondary', lineHeight: 1.8 }}>
            {t('privacyPolicy.section5Text')}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default PrivacyPolicy;
